import { PM_WORKBOOK } from '../../../../constants/accessToPages';

import PMWorkbook from './PMWorkbook';

export const pmWorkbookRouterConfig = {
  name: 'PM Workbook',
  path: '/pm-workbook',
  component: PMWorkbook,
  access: [PM_WORKBOOK]
};
